import React from 'react';
import { useTranslate } from 'ra-core';
import { PluginComponent } from 'react-markdown-editor-lite';
import Button from '@material-ui/core/Button';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatStrikethroughIcon from '@material-ui/icons/FormatStrikethrough';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import WrapTextIcon from '@material-ui/icons/WrapText';
import CodeIcon from '@material-ui/icons/Code';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
const FontButton = props => {
    const { type, onClick, children } = props;
    const translate = useTranslate();
    const handleClick = () => onClick(type);
    return (React.createElement(Button, { className: "button", title: translate(`apihub.markdown_editor.fonts.${type}`), onClick: handleClick }, children));
};
export default class AccessibleFonts extends PluginComponent {
    render() {
        const handleClick = type => {
            this.editor.insertMarkdown(type);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(FontButton, { type: "bold", onClick: handleClick },
                React.createElement(FormatBoldIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "italic", onClick: handleClick },
                React.createElement(FormatItalicIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "strikethrough", onClick: handleClick },
                React.createElement(FormatStrikethroughIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "unordered", onClick: handleClick },
                React.createElement(FormatListBulletedIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "order", onClick: handleClick },
                React.createElement(FormatListNumberedIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "quote", onClick: handleClick },
                React.createElement(FormatQuoteIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "hr", onClick: handleClick },
                React.createElement(WrapTextIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "inlinecode", onClick: handleClick },
                React.createElement(CodeIcon, { fontSize: "small" })),
            React.createElement(FontButton, { type: "code", onClick: handleClick },
                React.createElement(SettingsEthernetIcon, { fontSize: "small" }))));
    }
}
AccessibleFonts.pluginName = 'accessible-fonts';
//# sourceMappingURL=AccessibleFonts.js.map